import Expander from "@helsenorge/designsystem-react/components/Expander";
import { useGetResources } from "hooks/useGetResources";
import styles from "../../styles/oppgave-detaljer.module.scss";
import { Feltnavn, type Endringer } from "HNEntities/endringer";
import { getEndringTypeText } from "utils/changelog-utils";
import { useAppDispatch, useAppSelector } from "store/reducer";
import { fetchChangelog } from "store/thunks/thunk-oppgaveDetaljer";
import { createDateString } from "utils/date-utils";

type EndringerComponentProps = {
  oppgaveGuidParam?: string;
  oppgaveGuidProp?: string;
};

export const EndringerComponent = ({
  oppgaveGuidParam,
  oppgaveGuidProp,
}: EndringerComponentProps): React.JSX.Element => {
  const resources = useGetResources();
  const changelog = useAppSelector((state) => state.oppgaveDetaljer.changelog);
  const dispatch = useAppDispatch();

  const getStatusReason = (endringer: Endringer[]): string | undefined => {
    const statusReasonChange = endringer.find(
      (endring) => endring.EndretFelt === Feltnavn.StatusBegrunnelse,
    );
    return statusReasonChange ? statusReasonChange.NyVerdi : undefined;
  };

  const onExpandEnringslogg = () => {
    if (oppgaveGuidProp) {
      dispatch(fetchChangelog(oppgaveGuidProp));
    } else if (oppgaveGuidParam) {
      dispatch(fetchChangelog(oppgaveGuidParam));
    }
  };

  return (
    <div className={`${styles.detaljer_seksjon} ${styles.endringslogg}`}>
      <Expander
        title={resources?.dropdown_se_endringer || ""}
        onExpand={onExpandEnringslogg}
      >
        {changelog &&
          changelog.length > 0 &&
          changelog.map((entry, entryIndex) => (
            <>
              {entry.Endringer.length > 0 && (
                <div key={entryIndex}>
                  <div className={styles.endringslogg_dato_avsender}>
                    {`${createDateString(entry.EndretDato, "dd.MM.yyyy HH:mm")} - ${entry.EndretAv}:`}
                  </div>
                  <ul className={styles.endringslogg_list}>
                    {entry.Endringer.map(
                      (endring, index) =>
                        endring.EndretFelt !== Feltnavn.StatusBegrunnelse && (
                          <li key={`${entryIndex}-${index}`}>
                            {getEndringTypeText(
                              endring.EndretFelt,
                              resources,
                              endring.NyVerdi,
                              getStatusReason(entry.Endringer),
                            )}
                          </li>
                        ),
                    )}
                  </ul>
                </div>
              )}
            </>
          ))}
      </Expander>
    </div>
  );
};
